import React, { useState } from 'react';

import { Button } from '@mui/material';

import logoSrc from '@common/assets/study.ua.png';
import ChatRulesSteps from '@common/modules/Chat/Title/Rules/Steps';
import FirstStep from '@common/modules/Chat/Title/Rules/TeacherModalContent/Steps/FirstStep';
import SecondStep from '@common/modules/Chat/Title/Rules/TeacherModalContent/Steps/SecondStep';
import ThirdStep from '@common/modules/Chat/Title/Rules/TeacherModalContent/Steps/ThirdStep';
import { useTranslationContext } from '@common/modules/Chat/context';

import * as Styled from './styled';

interface TeacherModalContentProps {
	onClose: () => void;
}

const steps = [<FirstStep />, <SecondStep />, <ThirdStep />];

function ChatTeacherModalContent({ onClose }: TeacherModalContentProps) {
	const { t } = useTranslationContext();
	const [activeStep, setActiveStep] = useState(0);

	const isLastStep = activeStep === steps.length - 1;

	const handleNextStep = () => {
		if (activeStep < steps.length - 1) {
			setActiveStep((prev) => prev + 1);
		}
	};

	return (
		<Styled.Wrap>
			<Styled.Logo src={logoSrc} alt="Logo" />
			<ChatRulesSteps stepsLength={steps.length} activeStep={activeStep} isStudent={false} />
			{steps[activeStep]}
			{isLastStep ? (
				<Button variant="contained" onClick={onClose}>
					Ok
				</Button>
			) : (
				<Button variant="contained" onClick={handleNextStep}>
					{t('common.chat.continue')}
				</Button>
			)}
		</Styled.Wrap>
	);
}
export default ChatTeacherModalContent;
